<template>
    <div class="form-signin text-center">
        <!-- Errors -->
        <div v-if=response class="text-red"><p>{{response}}</p></div>

        <!-- login Button -->
        <b-button id="signin-button" v-on:click="signIn" class="btn btn-light">
            <!--<i class="fa fa-google-plus-official fa-3x"></i>-->
            Sign in with Google
        </b-button>
        <p class="mt-5 mb-3 text-muted">&copy; Subversive Data LLC, 2018</p>
    </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  computed: {
    ...mapGetters({ currentUser: 'currentUser' })
  },
  data: function (router) {
    return {
      section: 'Login',
      loading: '',
      response: ''
    }
  },
  updated () {
    this.checkCurrentLogin()
  },
  created () {
    this.checkCurrentLogin()
  },

  methods: {
    signIn: function () {
      Vue.googleAuth().signIn(this.onSignInSuccess, this.onSignInError)
    },
    onSignInSuccess: function (authorizationCode) {
      this.toggleLoading()
      this.resetResponse()
      this.$http.post(this.$apiEndpoint + '/login', { code: authorizationCode })
        .then(request => this.loginSuccessful(request))
        .catch(() => this.loginFailed())
    },
    onSignInError: function (error) {
      this.response = 'Failed to sign-in'
      console.log('GOOGLE SERVER - SIGN-IN ERROR', error)
    },
    toggleLoading: function () {
      this.loading = (this.loading === '') ? 'loading' : ''
    },
    resetResponse: function () {
      this.response = ''
    },
    loginSuccessful (req) {
      if (!req.data.token) {
        this.loginFailed()
        return
      }
      this.error = false
      localStorage.token = req.data.token
      this.$store.dispatch('login')
      this.$router.replace(this.$route.query.redirect || '/home')
    },
    loginFailed () {
      this.error = 'Login failed!'
      this.$store.dispatch('logout')
      delete localStorage.token
    },
    checkCurrentLogin: function () {
      if (this.currentUser) {
        this.$router.replace(this.$route.query.redirect || '/home')
      }
    }
  }
}
</script>

<style lang="css" scoped>
body {
  background: #605B56;
}

.login-wrapper {
  background: #fff;
  width: 70%;
  margin: 12% auto;
}

.form-signin {
  max-width: 330px;
  padding: 10% 15px;
  margin: 0 auto;
}
.form-signin .form-signin-heading,
.form-signin .checkbox {
  margin-bottom: 10px;
}
.form-signin .checkbox {
  font-weight: normal;
}
.form-signin .form-control {
  position: relative;
  height: auto;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  padding: 10px;
  font-size: 16px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
